import { render, staticRenderFns } from "./RecipientList.vue?vue&type=template&id=ecfec930&scoped=true"
import script from "./RecipientList.vue?vue&type=script&lang=ts"
export * from "./RecipientList.vue?vue&type=script&lang=ts"
import style0 from "./RecipientList.vue?vue&type=style&index=0&id=ecfec930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfec930",
  null
  
)

export default component.exports